import { Analytics, Environment } from '@1debit/analytics';

export const appEnvironment = (process.env.ENV || process.env.NODE_ENV) as Environment;

export const analyticsHandler = new Analytics({ env: appEnvironment, variant: 'onlyEventRouter' });
